export enum EForm {
  firstName = 'firstName',
  lastName = 'lastName',
  number = 'number',
  email = 'email',
  website = 'website',
};
